function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, ref, computed, openBlock, createElementBlock, normalizeClass, unref, createElementVNode, toDisplayString, createVNode } from 'vue';
import '../../../../hooks/index.mjs';
import { ElInput } from '../../../input/index.mjs';
import { usePagination } from '../usePagination.mjs';
import { paginationJumperProps } from './jumper.mjs';
import _export_sfc from '../../../../_virtual/plugin-vue_export-helper.mjs';
import { useLocale } from '../../../../hooks/use-locale/index.mjs';
import { useNamespace } from '../../../../hooks/use-namespace/index.mjs';
const _hoisted_1 = ["disabled"];
const __default__ = defineComponent({
  name: "ElPaginationJumper"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: paginationJumperProps,
  setup(__props) {
    const _useLocale = useLocale(),
      t = _useLocale.t;
    const ns = useNamespace("pagination");
    const _usePagination = usePagination(),
      pageCount = _usePagination.pageCount,
      disabled = _usePagination.disabled,
      currentPage = _usePagination.currentPage,
      changeEvent = _usePagination.changeEvent;
    const userInput = ref();
    const innerValue = computed(() => {
      var _a;
      return (_a = userInput.value) != null ? _a : currentPage == null ? void 0 : currentPage.value;
    });
    function handleInput(val) {
      userInput.value = val ? +val : "";
    }
    function handleChange(val) {
      val = Math.trunc(+val);
      changeEvent == null ? void 0 : changeEvent(val);
      userInput.value = void 0;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(unref(ns).e("jump")),
        disabled: unref(disabled)
      }, [createElementVNode("span", {
        class: normalizeClass([unref(ns).e("goto")])
      }, toDisplayString(unref(t)("el.pagination.goto")), 3), createVNode(unref(ElInput), {
        size: _ctx.size,
        class: normalizeClass([unref(ns).e("editor"), unref(ns).is("in-pagination")]),
        min: 1,
        max: unref(pageCount),
        disabled: unref(disabled),
        "model-value": unref(innerValue),
        "validate-event": false,
        label: unref(t)("el.pagination.page"),
        type: "number",
        "onUpdate:modelValue": handleInput,
        onChange: handleChange
      }, null, 8, ["size", "class", "max", "disabled", "model-value", "label"]), createElementVNode("span", {
        class: normalizeClass([unref(ns).e("classifier")])
      }, toDisplayString(unref(t)("el.pagination.pageClassifier")), 3)], 10, _hoisted_1);
    };
  }
}));
var Jumper = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "jumper.vue"]]);
export { Jumper as default };